import { useEffect, useRef } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import GenericSearchBar from 'modules/IMC/common/IMCHeader/components/GenericSearchBar';
import { useIMCContext } from 'modules/IMC/common/context';
import { useMessageCenterContext } from 'modules/IMC/MessageCenter/context';
import { DrawerTypes } from 'modules/IMC/common/context/IMCContext.interface';

export default function SearchBar({ placeholder }: { placeholder: string }) {
    const { currOpenDrawer } = useIMCContext();
    const { searchQuery, setSearchQuery } = useMessageCenterContext();

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current && currOpenDrawer === DrawerTypes.MESSAGE_CENTER && isDesktop) {
            inputRef.current.focus();
        }
    }, [currOpenDrawer, isDesktop]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value);
    };

    const handleClear = () => {
        setSearchQuery('');
    };

    return (
        <GenericSearchBar
            value={searchQuery}
            inputRef={inputRef}
            placeholder={placeholder}
            onChange={handleChange}
            onClear={handleClear}
            sx={{
                '& .MuiInputBase-root': {
                    borderColor: 'transparent',
                    '&:before, &:after': {
                        display: 'transparent',
                    },
                    '&:hover:not(.Mui-disabled):before': {
                        borderColor: 'transparent',
                    },
                    '&.Mui-focused': {
                        borderColor: 'transparent',
                    },
                },
            }}
        />
    );
}
